import { motion } from 'framer-motion';
import Image from 'next/image';
import type { IImage } from '../../types';

export interface PhotoGridBlockProps {
  image1?: IImage;
  image2?: IImage;
  image3?: IImage;
  caption: string;
}

export function PhotoGridBlock({ image1, image2, image3, caption }: PhotoGridBlockProps) {
  const imageReveal = {
    initial: { opacity: 0, y: 16 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-20% 0% -20% 0%' },
    transition: { ease: [0, 1, 1, 1], duration: 0.8 },
  };

  return (
    <section className="w-full">
      <div className="container mx-auto grid max-w-7xl gap-4">
        {/* Large image */}
        {image1?.src && (
          <motion.div {...imageReveal} className="relative aspect-video overflow-hidden rounded-xl">
            <Image src={image1.src} alt={image1.alt ?? ''} fill className="object-cover" sizes="(max-width: 768px) 100vw, 1200px" priority />
          </motion.div>
        )}

        {/* Bottom grid */}
        <div className="grid gap-4 xl:grid-cols-2">
          {image2?.src && (
            <motion.div {...imageReveal} transition={{ ...imageReveal.transition, delay: 0.1 }} className="relative aspect-square overflow-hidden rounded-xl">
              <Image src={image2.src} alt={image2.alt ?? ''} fill className="object-cover" sizes="(max-width: 768px) 100vw, 600px" />
            </motion.div>
          )}

          {image3?.src && (
            <motion.div {...imageReveal} transition={{ ...imageReveal.transition, delay: 0.2 }} className="relative aspect-square overflow-hidden rounded-xl">
              <Image src={image3.src} alt={image3.alt ?? ''} fill className="object-cover" sizes="(max-width: 768px) 100vw, 600px" />
            </motion.div>
          )}
          {caption && <motion.div className="type-caption-press" dangerouslySetInnerHTML={{ __html: caption }} />}
        </div>
      </div>
    </section>
  );
}
